import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
// import URL from '../../constants/urls'
// import queryString from 'query-string'
import successSvg from '../../assets/img/thank-you.svg'
import failedSvg from '../../assets/img/failed.svg'
import pendingSvg from '../../assets/img/pending.svg'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
// import { postAfterPayment } from '../../redux/actions/citationAction'
import 'react-toastify/dist/ReactToastify.css'
import { errorMessagePaymentFailed, messageSuccessPayment } from '../../utils/helper'
import { Circles } from 'react-loader-spinner'
import { useNavigate } from 'react-router-dom'

function ThankyouPage(props) {

  const { loader } = props

  const navigate = useNavigate()
  const partner = window.location.toString().split('/')[3]

  const [paymentData, setPayemntData] = useState(EMPTY_OBJECT)
  const [paymentStatus, setPaymentStatus] = useState('')



  useEffect(() => {
    window.scrollTo(0, 0)
    // let queries = queryString.parse(location.search)
    // if ((queries?.AuthorisationCode && queries?.AuthorisationCode !== null && queries?.AuthorisationCode !== '')) {

    // const payloadafterPayment = { 'TokenNo': queries?.TokenNo, 'AuthorisationCode': queries?.AuthorisationCode, 'MerchantRef': queries?.MerchantRef }

    // dispatch(postAfterPayment(payloadafterPayment)).then((res) => {
    // if (res?.data && res?.data !== null && res?.data !== undefined) {
    const paymentResponse = JSON.parse(localStorage.getItem('paymentResponse'))
    setPayemntData(paymentResponse)
    if (Number(paymentResponse?.payment_status) == 1) {
      setPaymentStatus('success')
    } else if (Number(paymentResponse?.payment_status) == 2) {
      setPaymentStatus('failed')
    } else if (Number(paymentResponse?.payment_status) == 0) {
      setPaymentStatus('pending')
    } else {
      setPaymentStatus('failed')
    }
    // } else {
    //   notify('error', res?.errors?.message)
    //   setPaymentStatus('failed')
    // }
    // }).catch((err) => {
    //   notify('error', err)
    // })
    // }
  }, [EMPTY_ARRAY])

  const handleBack = () => {
    const citation = localStorage.getItem('citation')
    if (citation !== '' || citation !== undefined || citation !== null) {
      navigate(-1)
    } else {
      navigate(`${partner}`)
      navigate(0)
    }
  }

  return (
    loader ? <span className='ms-2 d-flex justify-content-center'><Circles
      height="500"
      width="50"
      color='var(--bs-primary)'
      ariaLabel="circles-loading"
      visible={true}
    /></span> :
      <div>
        {/*paymentStatus === 'success'  */}
        {paymentStatus === 'success' &&
          <div className="container-fluid">
            <div className="card payment_Suceess mt-5">
              <div className="row align-items-center mt-3">
                <div className="col-auto">
                  <img src={successSvg} alt="" style={{ filter: 'hue-rotate(240deg)' }} />
                </div>
              </div>
              <div className="card-body">
                <h5 className="card-title text-success">Payment Success</h5>
                <p className="card-text">{messageSuccessPayment}</p>
                {/* user email and phone */}
                {(paymentData?.user) ?
                  <p>
                    {(paymentData) && `Your details have been sent to your registered email address ( ${paymentData?.user?.email} ).`}
                  </p>
                  : ''}
              </div>
              <div className="mb-3">
                <button className="btn btn-outline-secondary me-auto" type='button' onClick={handleBack} ><i className="fa fa-angle-left"></i> Back To Home</button>
              </div>
            </div>
          </div>}

        {/*paymentStatus === 'failed'  */}
        {paymentStatus === 'failed' &&
          <div className="container-fluid">
            <div className="card payment_Suceess mt-5">
              <div className="row align-items-center mt-3">
                <div className="col-auto">
                  <img src={failedSvg} alt="" className='' style={{ filter: 'invert(0.5) sepia(1) saturate(20) hue-rotate(330deg)' }} />
                </div>
              </div>
              <div className="card-body">
                <h5 className="card-title text-danger">Payment Failed</h5>
                <p className="card-text">{errorMessagePaymentFailed}</p>
              </div>
              <div className="mb-3">
                <button className="btn btn-outline-secondary me-auto" type='button' onClick={handleBack} ><i className="fa fa-angle-left"></i> Back To Home</button>
              </div>
            </div>
          </div>}

        {/*paymentStatus === 'pending'  */}
        {paymentStatus === 'pending' &&
          <div className="container-fluid">
            <div className="card payment_Suceess mt-5">
              <div className="row align-items-center mt-3">
                <div className="col-auto">
                  <img src={pendingSvg} alt="" className='' style={{ filter: 'invert(0.5) sepia(1) saturate( 10) hue-rotate(11deg) ' }} />
                </div>
              </div>
              <div className="card-body">
                <h5 className="card-title text-warning">Payment Pending</h5>
                <p className="card-text">{errorMessagePaymentFailed}</p>
              </div>
              <div className="mb-3">
                <button className="btn btn-outline-secondary me-auto" type='button' onClick={handleBack} ><i className="fa fa-angle-left"></i> Back To Home</button>
              </div>
            </div>
          </div>}
      </div>
  )
}

ThankyouPage.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  notify: PropTypes.func,
}

ThankyouPage.defaulProps = {
  dispatch: noop,
  loader: false,
  notify: noop,
}

function mapStateToProps({ citationReducer }) {
  return {
    loader: citationReducer?.loader,
  }
}
export default connect(mapStateToProps)(ThankyouPage)